<template>
  <ModelListPage
          lower-app-name="emarket"
          lower-model-name="order"
          version="2"
          title="订单列表">
  </ModelListPage>
</template>

<script>
import ModelListPage from './ModelListPage.vue'

export default {
  name: 'OrderList',
  components: {
    ModelListPage
  }
}
</script>



// WEBPACK FOOTER //
// OrderList.vue?d7bdd066